import React, { useEffect, useState } from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Activities/UpcomingEventsCard.style.css";
import PropTypes from "prop-types";
const UpcomingEventsCard = ({
  eventName,
  eventDate,
  indicator = false,
  indicatorColor = "",
  designation = "",
  handelCardClick,
}) => {
  const [textColor, setTextColor] = useState("");
  const [eventText, setEventText] = useState("");

  useEffect(() => {
    const getEventDay = () => {
      if (designation === "") {
        const parsedDate = eventDate.toString().split("-");
        const upcomingEventDate = new Date(parsedDate[0]);
        const currentDate = new Date();
        // Remove time component (set hours, minutes, seconds to zero) to get accurate days count
        currentDate.setHours(0, 0, 0, 0);
        upcomingEventDate.setHours(0, 0, 0, 0);

        // Calculate the difference in milliseconds and convert to full days
        const eventDelay = Math.ceil(
          (upcomingEventDate - currentDate) / (1000 * 60 * 60 * 24)
        );

        if (eventDelay === 0) {
          setTextColor("var(--greenColor)");
          setEventText("Today");
        } else if (eventDelay < -1) {
          setTextColor("var(--yelloColor)");
          setEventText(-eventDelay + " Day ago");
        } else if (eventDelay > 1) {
          setTextColor("var(--greenColor)");
          setEventText(eventDelay + " Days to go");
        } else if (eventDelay === 1) {
          setTextColor("var(--greenColor)");
          setEventText("Tomorrow");
        } else if (eventDelay === -1) {
          setTextColor("var(--yelloColor)");
          setEventText("Yesturday");
        }
      } else {
        setTextColor("var(--greenColor)");
        setEventText(designation);
      }
    };
    return () => {
      getEventDay();
    };
  }, [designation, eventDate]);
  return (
    <button className="upcomingEventsCard" onClick={() => handelCardClick()}>
      <div className={`flex-col g-05`}>
        <h3 className="text-align-left">{eventName}</h3>
        <p className="text-align-left">{eventDate}</p>
      </div>
      <div
        className={`t-10 poppins ${
          indicator ? "upcomingEventMeetingCardIndicatorParent" : ""
        }`}
        style={{
          "--eventCardsIndicatorColor": indicator ? indicatorColor : "",
          color: textColor,
        }}
      >
        {eventText}
      </div>
    </button>
  );
};

export default UpcomingEventsCard;
UpcomingEventsCard.propTypes = {
  eventName: PropTypes.string.isRequired,
  eventDate: PropTypes.string.isRequired,
  indicator: PropTypes.bool,
  indicatorColor: PropTypes.string,
  handelCardClick: PropTypes.func,
};
